"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryModeBusinessName = void 0;
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
const deliveryModeBusinessName = (deliveryModeName, delay) => deliveryModeName + (delay ? ` en ${convertDelay(delay)}` : '');
exports.deliveryModeBusinessName = deliveryModeBusinessName;
const singularUnits = {
    [module_logistic_interfaces_1.LogisticDelayUnit.Hour]: 'h',
    [module_logistic_interfaces_1.LogisticDelayUnit.Day]: 'j',
    [module_logistic_interfaces_1.LogisticDelayUnit.Week]: ' semaine',
    [module_logistic_interfaces_1.LogisticDelayUnit.Month]: ' mois',
    [module_logistic_interfaces_1.LogisticDelayUnit.WorkingDay]: ' jour ouvré'
};
const pluralUnits = {
    [module_logistic_interfaces_1.LogisticDelayUnit.Hour]: 'h',
    [module_logistic_interfaces_1.LogisticDelayUnit.Day]: 'j',
    [module_logistic_interfaces_1.LogisticDelayUnit.Week]: ' semaines',
    [module_logistic_interfaces_1.LogisticDelayUnit.Month]: ' mois',
    [module_logistic_interfaces_1.LogisticDelayUnit.WorkingDay]: ' jours ouvrés'
};
const getUnits = (count) => isSingular(count) ? singularUnits : pluralUnits;
const isSingular = (count) => count >= 0 && count < 2;
const convertDelay = (delay) => delay.value + getUnits(delay.value)[delay.unit];
